import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  TextField
} from "@material-ui/core";
import * as React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary
    },
    control: {
      padding: theme.spacing(1) * 2
    }
  });
interface Props extends WithStyles<typeof styles> {
  label: any;
}
class TextInputParentComponent extends React.Component<Props> {
  MyInputComponent = (props: any) => {
    const { component: Component, inputRef, ...other } = props;
    return <div {...other} />;
  };
  render() {
    const { children, label } = this.props;
    return (
      <React.Fragment>
        <TextField
          variant="outlined"
          label={label}
          fullWidth
          multiline
          InputLabelProps={{ shrink: true }}
          InputProps={{
            inputComponent: (props: any) => this.MyInputComponent(props)
          }}
          inputProps={{ children: children }}
        />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(TextInputParentComponent);
